import { environment } from 'src/environments/environment';

export const URLS = {
  GOBAL_URL: environment.url_point,

  PacketsForms:{
    AvaliableForms:'/api/PortalPackets/GetPacketDetails?ClientID=',
    UpdateStatus:'/api/PortalPackets/UpdatePacketStatus?Status=',
    GetPacketforms:'/api/PortalPackets/GetPacketFormData'
  },

  DashBoard:{
    getAppointments:'/api/Dashboard/GetAppointments?ClientID=',
    gettodos:'/api/Dashboard/GetToDo?ClientID=',
    getDashboardCounts:'/api/Dashboard/GetDashboardCounts?ClientID=', 
    getPdf : '/api/Dashboard/GetPDFDocument?ClientID=' 
  
  },

  Health_Record: {
    getproblemList: '/api/HealthRecord/GetProblemList?ClientID=',
    getmedicationList: '/api/HealthRecord/GetMedicationList?ClientID=',
    GetScheduleMedicationList: '/api/HealthRecord/GetScheduleMedicationList?ClientID=',
    getallergylist:'/api/HealthRecord/GetAllergyList?ClientID=',
    getnonallergylist:'/api/HealthRecord/GetNonAllergyList?ClientID=',
    getdocumentlist:'/api/HealthRecord/GetDocumentList?ClientID=',
    getlabresults:'/api/HealthRecord/GetLabResult?ClientID=',
    getvitalsign:'/api/HealthRecord/GetVitalSign?ClientID=',
    getdietorder:'/api/HealthRecord/GetDietOrder?ClientID=',
    getimmunization:'/api/HealthRecord/GetImmunization?ClientID=',
    getdiagnosis:'/api/HealthRecord/GetDiagnosis?ClientID=',
    getencounters:'/api/HealthRecord/GetEncounter?ClientID=',
    getappointments:'/api/HealthRecord/GetAppointments?ClientID=',
    getsmokingstatus:'/api/HealthRecord/GetSmokingStatus?ClientID=',
    getcontacts:'/api/HealthRecord/GetContact?ClientID=',
    gettreatment:'/api/HealthRecord/GetTreatmentPlan?ClientID=',
    getnursing :'/api/HealthRecord/GetPlanOfNursing?ClientID=',
    getlifePlan:'/api/HealthRecord/GetLifePlan?ClientID=',
    print:'/api/HealthRecord/HealthRecordPrint?ClientID=',
    getgad7:'/api/HealthRecord/GetGAD7?ClientID=',
   
    getPhq : '/api/HealthRecord/GetPHQ9?ClientID=',
    getSolaceVital : '/api/SBHHealthRecord/GetSolaceVitalSigns?ClientID=',
    getAudit : '/api/SBHHealthRecord/GetAudit?ClientID=',
    getAims : '/api/SBHHealthRecord/GetAIMS?ClientID=',
    getMadrs : '/api/SBHHealthRecord/GetMADRS?ClientID=',
    getPtsd : '/api/SBHHealthRecord/GetPTSD?ClientID=',
    gethamilton: '/api/SBHHealthRecord/GetHamilton?ClientID=',
    getprepprov : '/api/SBHHealthRecord/GetPrepProvider?ClientID=',
    getpreptherapy : '/api/SBHHealthRecord/GetPrepTherapy?ClientID=',
    getDisorder: '/api/SBHHealthRecord/GetMoodDisorderScale?ClientID=',
    getSleep : '/api/SBHHealthRecord/GetEpworthSleepinessscale?ClientID=',
    getBinge: '/api/SBHHealthRecord/GetBingeEatingScale?ClientID=',
    getBocs :'/api/SBHHealthRecord/GetYBOCS?ClientID='
  },
  gad7api : {
    insertgap7:'/api/GAD7/InsertGAD7',
    template_details:'/api/PHQ9/GetPHQGADOptions?ClientID='
  },
 
  // '/api/Profile/ValidateCompanyCode?Email= &CompanyCode= &Action='
  Profile: {
    login:'/api/Profile/Login?UserName=',
    MFA:'/api/Profile/VerifyOTP',
    profile:'/api/Profile/ClientProfileView',
    createProfile: '/api/Profile/CreateProfile',
    changepassword: '/api/Profile/changePassoword',
    checkcompanycode:'/api/Profile/ValidateCompanyCode',
    checkemail:'/api/Profile/ValidateEmail?EmailAddress=',
    insertClientProfile:'/api/Profile/InsertClientProfile',
    profileImage:'/api/Profile/GetClientProfileImage',
    getSecurityQA:'/api/Profile/GetSecurityQA',
    forgotpassword: '/api/Profile/UpdatePassword',
    createPreAdmission:'/api/Profile/CreatePreadmission',
    addClient:'/api/Profile/AddClient',
    getSecurityQuestion:'/api/Profile/GetSecurityQuestion',
    companylogo:'/api/Profile/GetCompanyLogo',
    broadcastMessage:'/api/Profile/GetBroadCastData?CompanyID=',
    switchclient:'/api/Profile/GetSwitchClientData',
    portalLogout:'/api/Profile/Logout?ClientID=',
    signUpData:'/api/Profile/GetClientSignUpData',
    getUserClient : '/api/Profile/GetUserClient',
    updatePolicy : '/api/Profile/UpdatePolicy',
    auditlog : '/api/Profile/Auditlog',
    createFCBDDApplication: '/api/Profile/CountyBoardApplication',

   
  },

  SSO:{
    GetUrl : '/api/SSO/GetUrl',
    GetUser : '/api/SSO/GetAuthUser',
    GetAuthOtp : '/api/SSO/SsoAuthGenerateOTP',
    VerifyToken : '/api/SSO/SsoVerifyToken'
  },

  Task: {
    taskdetails:'/api/Task/GetTaskDetails?ClientID=',
    taskUpdatedetails: '/api/Task/UpdateTaskDetails'
  },
  SecureMessage: {
    securemessage: '/api/SecureMessage/GetSecureMessages?ClientId=', 
    insertsecuremessage:'/api/SecureMessage/InsertInboxSecureMessage',   
    updatesentmessage:'/api/SecureMessage/UpdateSentSecureMessage',
    updateSecureMessagesread: '/api/SecureMessage/UpdateSecureMessagesread?Messageid=',
    deletesecuremessage:'/api/SecureMessage/DeleteSecureMessage?MessageId=',
    replysecuremessage:'/api/SecureMessage/GetReplySecureMessages?ClientID=',
    secureMessageDocument:'/api/SecureMessage/GetSecureMessageDocument?DocumentID=',
    auditsecuremessageinsert:'/api/SecureMessage/InsertAuditSecureMessage',
    auditsecuremessagedelete:'/api/SecureMessage/DeleteAuditSecureMessage'
  },
  UploadDoc: {
    getupdoc:'/api/PortalDocumentUpload/GetPortalDocumentUpload?ClientID=',
    doctype: '/api/PortalDocumentUpload/GetPortalDocumentTemplateDetail?clientID=',
    insertdoc:'/api/PortalDocumentUpload/InsertPortalDocumentUpload',
    updatedoc:'/api/PortalDocumentUpload/UpdatePortalDocumentUpload',
    deletedoc:'/api/PortalDocumentUpload/DeletePortalDocumentUpload',
    auditdocinsert:'/api/PortalDocumentUpload/InsertAuditPortalDocumentUpload',
    auditdocdelete:'/api/PortalDocumentUpload/DeleteAuditPortalDocumentUpload'
  },

  MyTeam : {
    myteam : '/api/Myteam/GetAssignedStaffList?ClientId=',
  },
  MailMerge: {
    savemail:'/api/MailMerge/InsertMailMergeDetails',
    editmail:'/api/MailMerge/UpdateMailMergeDetails',
    getmail: '/api/MailMerge/GetMailMergeTemplateDetail?CompanyID=',
    gettemplate: '/api/MailMerge/GetMailMergeTemplateDetail?CompanyID=',
    maildetails:'/api/MailMerge/GetMailMergeDetails?ClientID=',
    maildetailID:'/api/MailMerge/GetMailMergeDetails?ClientID=',
    deletemail:'/api/MailMerge/DeleteMailMergeDetails?LetterTemplateID='
  },
  Surveys:{
    getClinicalSurveys:'/api/ClinicSatisfactionSurvey/GetClinicSatisfactionSurvey?ClientID=',
    getSurveyTemplateDetails:'/api/ClinicSatisfactionSurvey/GetClinicSatisfactionSurveyTemplateDetail?clientID=',
     deleteClinicalSurvey:'/api/ClinicSatisfactionSurvey/DeleteClinicSatisfactionSurvey?ClinicSatisfactionSurveyID=',
     saveNewSurvey:'/api/ClinicSatisfactionSurvey/InsertClinicSatisfactionSurvey',
     editSurveys:'/api/ClinicSatisfactionSurvey/UpdateClinicSatisfactionSurvey',
  },
  RequestAppointment:{
    requestAppointment:'/api/RequestAppointment/GetAppointmentStaffDetails?ClientID=',
    getTimeZone:'/api/RequestAppointment/GetTimeZoneDetails',
    saveAppointment:'/api/RequestAppointment/InsertRequestAppointment',
    unavailtime:'/api/RequestAppointment/GetStaffavailDetails',
    auditrequestAppointment:'/api/RequestAppointment/InsertAuditRequestAppointment'
  },
  OnlinePayment:{
    createpayment:'/api/Squar/CreatePaymentRequest',
    dueAmount:'/api/Squar/GetDueAmount?ClientID=',
    clientStatement: '/api/Squar/GetClientStatement',
    wayster_insert :'/api/Squar/TestCreatePaymentRequest'
  },

  ccoLifePlan : {
    ccoLifePlan : '/api/CcoLifePlan/GetCCOLifePlan?ClientID=',
    getccoLifePlanPdf: '/api/CcoLifePlan/GetCCOPDFDocument',
    getccoUserType: '/api/CcoLifePlan/Getapproval?ClientID=',
    ccoLifePlanApproval : '/api/CcoLifePlan/InsertMemberRepresentativeApproval',
    getContactDetail : '/api/CcoLifePlan/GetContactsdetail?ClientID=',
    // GetCCOPortalDocumentUpload : '/api/CcoLifePlan/GetCCOPortalDocumentUpload?ClientID=',
    GetCCOPortalDocumentUpload : '/api/CcoLifePlan/GetCCOPortalDocumentUpload',
    insertCCODocumentUpload : '/api/CcoLifePlan/InsertCCOPortalDocumentUpload',
    deleteCCODoc : '/api/CcoLifePlan/DeleteCCOPortalDocumentUpload',
    ccoAllergies :'/api/CcoLifePlan/GetCCOAllergies?ClientID=',
    auditccoLifePlanApproval:'/api/CcoLifePlan/InsertAuditMemberRepresentativeApproval'
  },

  PHQ9 : {
    getPhqOptions : '/api/PHQ9/GetPHQGADOptions?ClientID=',
    insertPhq : '/api/PHQ9/InsertPHQ',
  },

  SBHVitalapi : {
    insertVital : '/api/SBHHealthRecord/InsertSolaceVitalSings'
  },
  
  Audit : {
    getAuditOptions : '/api/SBHHealthRecord/GetUDO?Type=',
    insertAudit:'/api/SBHHealthRecord/InsertAudit'
  },
    Aims: {
    InsertAimsAPI : '/api/SBHHealthRecord/InsertAIMS'
    },
    Madrs : {
    InsertMadrsAPI : '/api/SBHHealthRecord/InsertMADRS'
    },
    ptsd : {
      InsertPtsdAPI : '/api/SBHHealthRecord/InsertPTSD'
    },
    hemilton : {
      InsertHamilton :'/api/SBHHealthRecord/InsertHamilton',
    },
    prepProvider : {
      InsertProvider :'/api/SBHHealthRecord/InsertPrepProvider',
    },
    prepTherapy : {
      InsertTherapy: '/api/SBHHealthRecord/InsertPrepTherapy'
    },
    DisorderScale : {
      InsertDisorder : '/api/SBHHealthRecord/InsertMoodDisorderScale'
    },
    SleepScale : {
      InsertSleep : '/api/SBHHealthRecord/InsertEpworthSleepinessscale'
    },
    BingeScale :{
      InsertBinge :'/api/SBHHealthRecord/InsertBingeEatingScale'
    },
    ybocsScale : {
      InsertBocs :'/api/SBHHealthRecord/InsertYBOCS'
    }



}

export const Constant ={
  Timing:{
    timeoutWarningInSeconds : 120
  },
  getId:{
    phqId : 0,
    gadId : 0,
    surveyId : 0,
    SBHVitalID : 0,
    auditID: 0,
    aimsID: 0,
    madrsID: 0 ,
    ptsdID: 0,
    hamID : 0,
    provID: 0 ,
    TherapyID: 0,
    SLeepID:0,
    BingeID : 0,
    BcosID :0
  }
 }
